import { createSlice } from '@reduxjs/toolkit';
import { IMdbError } from '../../../errorObjects/MdbError';

const initialState: IMdbError | null = null;

export const noteDeleteFailureSlice = createSlice({
  name: 'noteDeleteFailure',
  initialState,
  reducers: {
    // action has a payload with an error
    noteDeleteFailureChange(state, action) {
      return action.payload;
    },
        
    // action has a payload with a null value
    noteDeleteFailureClear(state) {
      return null;
    },
  },
})

// Action creators are generated for each function in reducer)
export const { noteDeleteFailureChange, noteDeleteFailureClear } = noteDeleteFailureSlice.actions;

// export the core reducer for the slice
export const noteDeleteFailureReducer = noteDeleteFailureSlice.reducer;

export default noteDeleteFailureSlice.reducer;